import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tabContent: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 15,
    marginTop: 15,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    '& h6 ': {
      fontSize: theme.typography.fontSize,
      marginBottom: 5,
    },
  },
  contentIcons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    '& * ': {
      color: theme.palette.primary.main,
    },
  },
  loadingSection: {
    display: 'flex',
    justifyContent: 'center',
    padding: 15,
  },
  tabName: {
    overflowWrap: 'anywhere',
  },
}))

export default useStyles
